(() => {
  'use strict';

  if (customElements.get('deferred-country-flags')) return;

  class IzzatDeferredCountryFlags extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.button = this.querySelector('button[aria-controls]');
      this.panel = this.querySelector('.disclosure__list-wrapper');
      this._onOpen = this.scheduleHydration.bind(this);
      this.button?.addEventListener('click', this._onOpen, { once: true });
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this._onOpen);
      this.observer?.disconnect();
      this._initialized = false;
    }

    scheduleHydration() {
      window.requestAnimationFrame(() => this.hydrateVisibleFlags());
    }

    hydrateVisibleFlags() {
      const images = [...this.querySelectorAll('img[data-izzat-country-flag][data-src]')];
      if (!images.length) return;

      if (!('IntersectionObserver' in window) || !this.panel) {
        images.forEach((image) => this.hydrateFlag(image));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.hydrateFlag(entry.target);
        });
      }, { root: this.panel, rootMargin: '160px 0px' });

      images.forEach((image, index) => {
        if (index < 12) this.hydrateFlag(image);
        else this.observer.observe(image);
      });
    }

    hydrateFlag(image) {
      const source = image?.dataset?.src;
      if (!source) return;
      image.src = source;
      image.removeAttribute('data-src');
      this.observer?.unobserve(image);
    }
  }

  customElements.define('deferred-country-flags', IzzatDeferredCountryFlags);
})();
